export class Section {
  constructor(el: HTMLElement) {
    if (el.getAttribute("data-section") === "disabled") {
      el.ariaDisabled = "true";
    }

    el.querySelector("h2").addEventListener("click", () => {
      if (el.getAttribute("data-section") === "close") {
        el.setAttribute("data-section", "open");
      } else {
        el.setAttribute("data-section", "close");
      }
    });
  }
}
